import { render } from "./FaceRecognition.vue?vue&type=template&id=aa9d2faa&ts=true"
import script from "./FaceRecognition.vue?vue&type=script&lang=ts"
export * from "./FaceRecognition.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__